/**
 * Report-period helpers. Kept out of the page/modal components so those files
 * export components only (react-refresh/only-export-components).
 *
 * The backend's period is always the string `YYYY-MM` — validated with
 * `@Matches(/^\d{4}-\d{2}$/)` on both the generate DTO and the list query, and
 * stored as `VarChar(7)`. Never a Date, and never a range.
 */

/** Matches the backend's own `previousMonthPeriod()` — the scheduler's target. */
export const previousMonthPeriod = (now: Date = new Date()): string => {
  const d = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

/**
 * `2025-06` -> `June 2025`.
 *
 * Built and formatted in UTC deliberately: constructing a local-time Date for
 * the 1st of a month and then formatting it can roll back into the previous
 * month for users behind UTC, which would mislabel every report in Lagos-west
 * timezones. Unparseable input is returned untouched rather than rendered as
 * "Invalid Date".
 */
export const formatPeriod = (period: string): string => {
  const match = /^(\d{4})-(\d{2})$/.exec(period);
  if (!match) return period;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1));
  return date.toLocaleDateString(undefined, { month: 'long', year: 'numeric', timeZone: 'UTC' });
};
